/* eslint-disable */
var $ = window.jQuery = require('jquery');

import {
  bus
} from '@/main';

export default {
  name: 'header-searchbar',
  components: {},
  data() {
    return {
      search: '',
      isOpen :false,
      searchList:'',
      filterinput:''
    }
  },
  computed: {

  },
  mounted() {
    bus.$on('ShowSearchKeyWord', (data) => {
      this.search = data;
    });
    var _self = this
    $(document).ready(function(){
      $(".autocomplete_search").click(function(){
        $('.header-search').addClass("show_search")
      })
      $(document).click(function(event) {
        if (!$(event.target).closest(".autocomplete_search, .autocomplete-results").length) {
          _self.isOpen = false;
          $('.header-search').removeClass("show_search")
          $('.autocomplete-results').addClass("d-none")
          $('.httploader').removeClass("searchLoaderhide")
          $('.routeloader').removeClass("searchLoaderhide")
        }
      });
    })
  },
  methods: {
    validateSearchCourseBeforeSubmit() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$router.push('/course/search/result/' + this.search + '/')
          this.$validator.reset()
        }
      })
    },
    toggleSearch: function() {
      let windowWidth = $(window).width();
      if ((windowWidth < 801) && (windowWidth > 581)) {
        $('.header-search').toggleClass('showSearch', 7000);
        $(this).closest('div').find('.form-control').focus();
      }
    },
    onChange(){
      // console.log(this.search, "Serach Keyword")
      $('.header-search').addClass("show_search")
      if(this.search.length >= 3){
        $('.httploader').addClass("searchLoaderhide")
        $('.routeloader').addClass("searchLoaderhide")
        this.isOpen = true;
        $('.autocomplete-results').removeClass("d-none")
        this.$store.dispatch('filterField', { name: this.search }).then((response) => {
          if (response.data.code == '2000') {
            this.searchList = response.data.data.results
            // console.log(response.data.data.results, "search data")
          }
        })
      }else{
        this.isOpen = false;
      }
    },
    searchListFind(SearchKeyName){
      if(SearchKeyName){
        $('.httploader').removeClass("searchLoaderhide")
        $('.routeloader').removeClass("searchLoaderhide")
        this.filterinput = SearchKeyName
        this.$validator.validateAll().then((result) => {
          if (result) {
            this.$router.push('/courses/search/result/' + SearchKeyName + '/')
            this.isOpen = false;
            this.$validator.reset()
          }
        })
      }
    },
  },
}